/* Smart Swatches – keeps the thumbnail strip in sync with the variant's photo group.
   Dawn already swaps the main gallery slides when a variant changes; this makes the
   thumbnails follow (hide other variants' photos, same order as the main slides). */
(function () {
  if (window.__smartSwatchesInit) return;
  window.__smartSwatchesInit = true;

  function syncThumbnails(gallery) {
    var viewer = gallery.querySelector('[id^="Slider-Gallery"]');
    var list = gallery.querySelector('[id^="Slider-Thumbnails"]');
    if (!viewer || !list) return;

    var order = Array.prototype.map.call(viewer.querySelectorAll('li[data-media-id]'), function (li) {
      return li.dataset.mediaId;
    });
    var visible = new Set(order);
    var items = Array.prototype.slice.call(list.querySelectorAll('li[data-target]'));
    var byTarget = new Map(items.map(function (li) { return [li.dataset.target, li]; }));

    items.forEach(function (li) {
      li.classList.toggle('ss-thumb-hidden', !visible.has(li.dataset.target));
      li.classList.remove('thumbnail-list_item--variant');
    });
    order.forEach(function (id) {
      var li = byTarget.get(id);
      if (li) list.appendChild(li);
    });
    items.forEach(function (li) {
      if (!visible.has(li.dataset.target)) list.appendChild(li);
    });

    var count = order.length;
    var slider = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (slider) {
      slider.classList.toggle('ss-thumb-hidden', count < 2);
      slider.classList.toggle('thumbnail-slider--no-slide', count <= 3);
      if (typeof slider.resetPages === 'function') slider.resetPages();
    }
  }

  function syncAll() {
    document.querySelectorAll('media-gallery').forEach(syncThumbnails);
  }

  /* Clicking a picture/colour swatch that doesn't exist with the current size etc.
     selects the closest real variant instead of showing "Unavailable".
     Runs in the capture phase, before Dawn's variant-selects reads the selection. */
  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!input || !input.classList || !input.classList.contains('ss-input')) return;
      var ids = input.dataset.ssSwitch;
      if (!ids) return;
      var root = input.closest('variant-selects');
      if (!root) return;
      ids.split(',').forEach(function (id) {
        if (!id) return;
        var other = root.querySelector('input.ss-input[data-option-value-id="' + id + '"]');
        if (other) other.checked = true;
      });
    },
    true
  );

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      window.requestAnimationFrame(syncAll);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
